import { render, staticRenderFns } from "./Busca.vue?vue&type=template&id=017f1631&scoped=true&"
import script from "./Busca.vue?vue&type=script&lang=js&"
export * from "./Busca.vue?vue&type=script&lang=js&"
import style0 from "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css?vue&type=style&index=0&lang=css&"
import style1 from "./Busca.vue?vue&type=style&index=1&id=017f1631&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017f1631",
  null
  
)

export default component.exports